






















import Vue from 'vue'
import UiInput from '../UiInput'
export default (Vue as typeof UiInput).extend({
  name: 'UiTextarea',
  components: {
    UiInput
  },
  extends: UiInput
})
